
	<div class= "container">

	<div class= "container" *ngIf="option == 1">
		<legend><span>Actualizar item de la Compra</span></legend>
		<form *ngIf="form" [formGroup]="form"  (ngSubmit)="update(1)">
            <div class="wrap-fields">
                <div class="field">
                    <mat-form-field>
                        <mat-select required [formControl]="form.controls['store']">
                            <mat-option *ngFor="let s of stores" [value]="s.id">{{s.nameStore}}</mat-option>
                        </mat-select>
                        <mat-label><b>Acopio</b></mat-label>
                    </mat-form-field>
                    <app-validator [control]="form.controls['store']"></app-validator>
                </div>
                <div class="field">
                    <mat-form-field>
                        <mat-select required [formControl]="form.controls['itemType']">
                            <mat-option *ngFor="let it of itemType" [value]="it.id">{{it.nameItemType}}</mat-option>
                        </mat-select>
                        <mat-label><b>Tipo</b></mat-label>
                    </mat-form-field>
                    <app-validator [control]="form.controls['itemType']"></app-validator>
                </div>

                <!--<button class="buttonStyle2" (click)="deleteItemType(i)" title="Eliminar Detalle a la Cosecha">
                    <i class="material-icons">delete_sweep</i>
                </button>-->
            </div>

            <div class="wrap-fields">
                <div class="field">
                    <mat-form-field class="example-full-width">
                        <input matInput required formControlName="costItemType" placeholder="Precio" class="example-right-align">
                    </mat-form-field>
                    <app-validator [control]="form.controls['costItemType']"></app-validator>
                </div>
                <div class="field form-field">
                    <mat-form-field class="example-full-width">
                        <input matInput required formControlName="amountInvoiceDetail" placeholder="Peso" class="example-right-align">
                    </mat-form-field>
                    <app-validator [control]="form.controls['amountInvoiceDetail']"></app-validator>
                </div>
				<!--
				<button class="buttonStyle" (click)="addPurities(form.controls.purities)" title="Añadir Pureza a la Cosecha">
                    <i class="material-icons">add_shopping_cart</i>
				</button>
				-->
            </div>

			<!--
            <div formArrayName="invoiceDetailPurity">
                <div style="margin-top:5px; margin-bottom:5px;" *ngFor="let p of item.get('invoiceDetailPurity').controls;
                let j=index" >
                    <fieldset>
                        <legend><h4> Pureza{{j+1}}: </h4></legend>
                            <div [formGroupName]="j">
                                <div class="wrap-fields">
                                    <div class="field">
                                        <mat-form-field class="full-width">
                                            <mat-select required [formControl]="p.controls['idPurity']">
                                                <mat-option *ngFor="let p of purits" [value]="p.id">{{p.namePurity}}</mat-option>
                                            </mat-select>
                                            <mat-label><b>Grano</b></mat-label>
                                        </mat-form-field>
                                        <app-validator [control]="p.controls['idPurity']"></app-validator>
                                    </div>
                                </div>

                                <div class="wrap-fields">
                                    <div class="field">
                                        <mat-form-field class="full-width">
											<input matInput required formControlName="valueRateInvoiceDetailPurity"
											placeholder="Porcentaje" class="example-right-align">
                                        </mat-form-field>
                                        <app-validator [control]="p.controls['valueRateInvoiceDetailPurity']"></app-validator>
                                    </div>
									<button class="buttonStyle2" (click)="deletePurities(item.controls.purities, j)"
									title="Eliminar Detalle a la Cosecha">
                                        <i class="material-icons">delete_sweep</i>
                                    </button>
                                </div>
                            </div>
                    </fieldset>
                </div>
            </div>-->

            <div class="wrap-fields">
                <div class="field">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="nameReceived" placeholder="Recibido por">
                    </mat-form-field>
                    <app-validator [control]="form.controls['nameReceived']"></app-validator>
                </div>

                <div class="field">
                    <mat-form-field>
                        <input matInput formControlName="nameDelivered" placeholder="Entregado por">
                    </mat-form-field>
                    <app-validator [control]="form.controls['nameDelivered']"></app-validator>
                </div>
            </div>

            <div class="wrap-fields">
                <div class="field">
                    <mat-form-field class="full-width">
                        <input matInput formControlName="noteInvoiceDetail" placeholder="Observaciones">
                    </mat-form-field>
                    <app-validator [control]="form.controls['noteInvoiceDetail']"></app-validator>
                </div>
            </div>
			<div class="options row">
				<button mat-raised-button class="btn-text" type="submit" [disabled]="form?.invalid" >Guardar</button>
			</div>
		</form>
	</div>

	<div *ngIf="option == 2">
		<form *ngIf="form" [formGroup]="form"  (ngSubmit)="update(2)">
		<legend><span>Actualizar item de la Cosecha</span></legend>
			<div class="wrap-fields">
				<div class="field">
					<mat-form-field>
						<mat-select required [formControl]="form.controls['farm']">
							<mat-option *ngFor="let f of farms" [value]="f.id">{{f.nameFarm}}</mat-option>
						</mat-select>
						<mat-label><b>Granja</b></mat-label>
					</mat-form-field>
				</div>
				<div class="field">
					<mat-form-field>
						<mat-select required [formControl]="form.controls['lot']">
							<mat-option *ngFor="let l of lots" [value]="l.id">{{l.nameLot}}</mat-option>
						</mat-select>
						<mat-label><b>Lote</b></mat-label>
					</mat-form-field>
					<app-validator [control]="form.controls['lot']"></app-validator>
				</div>
				<div class="field">
					<mat-form-field>
						<mat-select required [formControl]="form.controls['itemType']">
							<mat-option *ngFor="let it of itemType" [value]="it.id">{{it.nameItemType}}</mat-option>
						</mat-select>
						<mat-label><b>Grano</b></mat-label>
					</mat-form-field>
					<app-validator [control]="form.controls['itemType']"></app-validator>
				</div>
				<!--
				<button class="buttonStyle2" (click)="deleteItemType(i)" title="Eliminar Detalle a la Cosecha">
					<i class="material-icons">delete_sweep</i>
				</button>-->
			</div>

			<div class="wrap-fields">
				<div class="field">
					<mat-form-field class="full-width2">
						<input matInput required formControlName="amountInvoiceDetail" placeholder="Cantidad"
						class="example-right-align">
					</mat-form-field>
					<app-validator [control]="form.controls['amountInvoiceDetail']"></app-validator>
				</div>
				<div class="field">
					<mat-form-field class="full-width">
						<input matInput formControlName="noteInvoiceDetail" placeholder="Observaciones">
					</mat-form-field>
					<app-validator [control]="form.controls['noteInvoiceDetail']"></app-validator>
				</div>
			</div>

			<div class="options row">
				<button mat-raised-button class="btn-text" type="submit" [disabled]="form?.invalid" >Guardar</button>
			</div>
		</form>
	</div>

	</div>
	